import React from 'react';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import truncate from 'lodash/truncate';
import CopyLinkButton from 'common/components/copy_link_button';
import { shareLink } from 'common/utils';

const Share = ({ link, participantsUrl, toggleAddParticipants }) => {

  const message = `I'd love your opinions on a design project I'm running on @crowdspring - ${link}`;

  return (
    <div className="focus-group-share">
      <ul>
        <li>
          <div className="copy-link-box">
            <h4>Share this link so that people can participate:</h4>
            <Link to={link} className="link" target="_blank">{ truncate(link, { length: 25 }) }</Link>
            <CopyLinkButton link={link} className="btn btn-primary" label="Copy to clipboard"
              hideIcon={true} />
            <p>
              Add this link to an email, chat, on Twitter, Facebook, or to a text message.
              Anyone who clicks it will be able to give feedback in your focus group.
              You can also <Link to={participantsUrl} onClick={toggleAddParticipants}>
              invite people individually</Link>.
            </p>
          </div>
        </li>
        <li>
          <button onClick={partial(shareLink, message, 'twitter')}>
            <i className="fa fa-fw fa-twitter" /> Tweet
          </button>
        </li>
        <li>
          <button onClick={partial(shareLink, link, 'facebook')}>
            <i className="fa fa-fw fa-facebook" /> Share
          </button>
        </li>
      </ul>
    </div>
  );
}

export default Share;



// WEBPACK FOOTER //
// ./focus_groups/components/share.jsx